import api from '../lib/utils/apiConfig';

const uploadService = {
  /**
   * Upload an image to S3 via backend
   * @param {File} file 
   * @returns {Promise<string>} - Public S3 URL
   */
  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await api.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        return response.data.url;
      } else {
        throw new Error(response.data.message || 'Upload failed');
      }
    } catch (error) {
      console.error('Upload Service Error:', error);
      throw error;
    }
  },
};

export default uploadService;
